<template>
  <div>
    <el-col style="flex:1;border-right: 1px solid #D7D7D7;padding-right: 30px;" :lg="19" :xs="24" :md="18" :sm="24">
      <template>
        <div class="product-container">
          <div class="product-wrapper">
            <div class="product-wrapper-left">
              <template>
                <div class="">
                  <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">订单号</p>
                  <p>
                  {{r.merchant_order_info_list.map(item=>{
  return item.merchant_order_no
                    }).join(",")}}
                  </p>
                </div>

              </template>
              <template>
                <div class="margin-top-sm">
                  <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">任务号</p>
                  <p>
                   {{r.order_no_list.join(",")}}
                  </p>
                </div>

              </template>
              <template>
                <div class="margin-top-sm">
                  <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">费用项目</p>
                  <p>
                    {{r.fee_item_type_list.map(item=>{
                    return feeItemTypeList.find(each=>each.value==item).content;
                    }).join(',')}}
                  </p>
                </div>

              </template>
              <template>
                <div class="margin-top-sm">
                  <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">计费方式</p>
                  <p>
                    {{handleBillDetail(r)}}
                  </p>
                </div>
              </template>
            </div>
            <div class="product-wrapper-right">

              <template>
                <div class="">
                  <p style="color:#888888;margin-bottom:10px;">创建人</p>
                  <p> {{r.create_account_name}} <span class="margin-left-2px">{{r.create_time}}</span></p>
                </div>
              </template>
              <template v-if="r.update_account_name">
                <div class="margin-top-sm">
                  <p style="color:#888888;margin-bottom:10px;">更新人</p>
                  <p> {{r.update_account_name}}<span class="margin-left-2px">{{r.update_time}}</span></p>
                </div>
              </template>
              <template v-if="r.bill_settlement_no_list&&r.bill_settlement_no_list.length">
                <div class="margin-top-sm">
                  <p style="color:#888888;margin-bottom:10px;">结算单</p>
                  <p> {{r.bill_settlement_no_list.join(",")}}</p>
                </div>
              </template>
            </div>
          </div>

        </div>
      </template>
    </el-col>
    <el-col style="padding-left:50px;" :span="5">
      <div>
        <template>
          <div>
            <template>
              <div class="margin-top-sm">
                <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">备注</p>
                <p style="margin-bottom: 10px;">
                  <a class="content_link" target="_blank">{{ r.remark}}</a>
                </p>
              </div>
            </template>
            <template v-if="r.bill_status==0">
              <el-button type="info" class="margin-top-sm" @click="updateBill()">
                关联结算单
              </el-button>
            </template>
          </div>
        </template>
      </div>
    </el-col>
  </div>
</template>

<script>

  let _ = require('lodash')

  export default {
    name: 'BillCollapseBody',
    props: ['r', 'index', 'feeItemTypeList'],
    components: {},
    data() {
      return {}
    },
    async mounted() {

    },
    methods: {
      handleBillDetail(item) {
        let result;
        if (item.calculating_method == 1) {
          result = (item.calculating_method_detail.percentage * 100).toFixed(0) + '%'
        } else if (item.calculating_method == 2) {
          result = '固定费率' + item.calculating_method_detail.fixed_exchange_rate
        } else if (item.calculating_method == 3) {
          result = '固定金额' + item.calculating_method_detail.fixed_amount;
        }
        return result;
      },
      displayFirstLine(str) {
        return str.split("\<br>")[0]
      },
      async updateBill(index) {
        this.$emit('updateBill', this.r)
      },
    }
  }
</script>

<style lang="scss">
  .content_link {
    color: #303133;
  }

  .product-container {
    padding: 15px 0;
    border-bottom: 1px solid #D7D7D7;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }

    &.order {
      display: flex;
      justify-content: space-between;
    }
  }

  .product-wrapper {
    display: flex;
    justify-content: space-between;

    .product-wrapper-left.lika {
      margin-left: 237px;

      &.taskDisplay {
        margin-left: 200px;
      }
    }

    .product-wrapper-right {
      text-align: right;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &.order {
      flex: 1;
      border-right: 1px solid #D7D7D7;
      padding-right: 25px;
      line-height: 1;
    }

    .product-wrapper-right.order p {
      color: #888888;
    }
  }

  .product-item {
    display: flex;
    height: 120px;
    margin-bottom: 30px;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .product-detail {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      position: relative;
      top: -3px;
      margin-left: 20px;

      .product-name {
        font-size: 14px;
        color: #333333;
      }

      .product-price {
        line-height: 32px;
        color: black;

        label {
          font-size: 18px;
        }
      }

      .product-price del {
        font-size: 16px;
      }
    }
  }

  .product-price label.danger {
    font-size: 18px;
    color: #FF4650;
  }

</style>



// WEBPACK FOOTER //
// src/pages/orders/amount_bill/BillCollapseBody.vue